import {BaseOptions} from '../../../../dialog/options/base.options';

export class AddOrUpdateServicesOptions extends BaseOptions {
  service?: any;
  productsAttributes?: any;
  categoryId?: string;
  branchId?: string;

  onInsertOrUpdateFinished() {
  }
}
